/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSportsVolleyballIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-sports-volleyball"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M22.2 8.6L13.32 3.48L13.32 1.3Q16.45 1.7 18.8 3.67Q21.15 5.65 22.2 8.6ZM6.6 13.57L6.6 2.67Q7.55 2.17 8.56 1.79Q9.57 1.4 10.7 1.3L10.7 11.25ZM2.1 16.2Q1.68 15.2 1.45 14.16Q1.23 13.13 1.23 12Q1.23 10.05 1.91 8.2Q2.6 6.35 3.95 4.83L3.95 15.1ZM6.65 21.32Q5.7 20.82 4.9 20.11Q4.1 19.4 3.45 18.55L12 13.55L16.07 15.93ZM12 22.8Q11.47 22.8 10.94 22.76Q10.4 22.73 9.82 22.6L18.75 17.48L20.57 18.5Q19.05 20.52 16.8 21.66Q14.55 22.8 12 22.8ZM21.93 16.2L13.32 11.25L13.32 6.53L22.8 12Q22.8 13.1 22.57 14.15Q22.35 15.2 21.93 16.2Z" fill={color} />
    </svg>
  );
}
